export const siteBrand = {
  name: "暗线",
  fullName: "暗线 · 独家爆料线索征集中心",
  slogan: "让每一条线索，都抵达该去的地方",
  intro:
    "暗线是一个面向知情者与内部人士的独家爆料线索征集入口。我们开放投稿与私信通道，接收你手中的原始素材与文件，负责核实、脱敏与呈现。",
  email: "tips@anxian-tips.com",
  fallbackChannel: "tips@anxian-tips.com",
  operatorLine: "由独立核实小组运营 · 不隶属于任何商业机构",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "投稿指南", to: "/guide" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export const siteStats = [
  { value: "12,600+", label: "累计接收线索" },
  { value: "380+", label: "已核实并呈现" },
  { value: "72h", label: "平均首次回应" },
  { value: "100%", label: "可选择全程匿名" },
];